import { render, staticRenderFns } from "./DevicesCard.vue?vue&type=template&id=db5c2d40&scoped=true&"
import script from "./DevicesCard.vue?vue&type=script&lang=ts&"
export * from "./DevicesCard.vue?vue&type=script&lang=ts&"
import style0 from "./DevicesCard.vue?vue&type=style&index=0&id=db5c2d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5c2d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
